export default {
  // Breakpoints
  xsmall: '20em', // +/- 320px
  small: '26em', // +/- 416px
  medium: '40em', // +/- 640px
  large: '59em', // +/- 944px
  xlarge: '78em', // +/- 1248px
};
